import { Customer, CustomerDetails, permissionAllowed } from "@ews/react-data";
import { useState } from "react";
import { useNamedRoutes } from "../../../NamedRoutes";

import
{
    useCustomerDetails,
    useModifyCustomer,
    useModifyCustomerDetails
} from "../../../ReactData/customer";

import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonItem } from "@ionic/react";
import { useMyPermissions } from "../../../Login/LoginProvider";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { SettingsLanguageTypeAhead } from "../../../Settings/SettingsLanguageTypeAhead/SettingsLanguageTypeAhead";
import CustomerTypeAhead from "../../CustomerTypeAhead";
import style from "./../SettingsOvererlay/SettingsOverlay.module.scss";
import { MainSettingsProps } from "./types";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import Feature from "../../../Feature";

const MainSettings: React.FC<MainSettingsProps> = ({ customer, }) =>
{
    const { translate: t } = useL10n();
    const { params } = useNamedRoutes();
    const { id } = params();

    const myPermissions = useMyPermissions();
    const allowedToEdit = permissionAllowed(myPermissions.createCustomer || 0);

    const details = useCustomerDetails(customer.id || id!);
    const modifyCustomer = useModifyCustomer();
    const modifyCustomerDetails = useModifyCustomerDetails();

    //const parentCustomer = useCustomer(customer.parentId || "");

    const [allDetails, setAllDetails] = useState<boolean>(true);

    function saveCustomerDetails(key: keyof CustomerDetails, value: any)
    {
        if (!customer.id || !(key in details)) return;
        modifyCustomerDetails(customer.id, { [key]: value } as CustomerDetails);
    }

    function saveCustomer(key: keyof Customer, value: any)
    {
        if (!customer.id || !(key in customer)) return;
        modifyCustomer(customer.id, { [key]: value } as Customer);
    }

    return <>
        <SettingsCol>
            {/* <IonButton expand="full" onClick={() => { setAllDetails(!allDetails); }}>{t('show all details')}</IonButton> */}
            <SettingsCheckbox text={"COM_BANNERS_HEADING_ACTIVE"} disabled checked={true} onChange={(checked) => { }} />

            <SettingsLabel
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_USERS_CUSTOMERID"}
                value={customer.customerNumber + "" || ""} />



            <SettingsTextInput
                disabled={!allowedToEdit}
                required={true}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_NAME"}
                endText={' 1'}
                inputType={"text"}
                value={customer.name}
                onChange={(value) =>
                {
                    if (customer.name === value) return;
                    saveCustomer("name", value);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                hidden={!allDetails}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_NAME"}
                endText={' 2'}
                inputType={"text"}
                value={details?.name2}
                onChange={(value) =>
                {
                    if (details?.name2 === value) return;
                    saveCustomerDetails("name2", value);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                hidden={!allDetails}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_NAME3"}
                inputType={"text"}
                value={details?.name3}
                onChange={(value) =>
                {
                    if (details?.name3 === value) return;
                    saveCustomerDetails("name3", value);
                }} />

            <SettingsTextInput
                disabled={!allowedToEdit}
                hidden={!allDetails}
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_CUSTOMER_NUMBER_LABEL"}
                tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_CUSTOMER_FIELD_CUSTOMER_NUMBER_DESC")} />}
                inputType={"text"}
                value={customer?.internalRef}
                onChange={(value) =>
                {
                    if (customer?.internalRef === value) return;
                    saveCustomer("internalRef", value);
                }} />


            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_ADDRESS1_LABEL"}
                inputType={"text"}
                value={details?.street}
                onChange={(value) =>
                {
                    if (details?.street === value) return;
                    saveCustomerDetails("street", value);
                }} />

            <SettingsTextInput
                disabled={!allowedToEdit}
                hidden={!allDetails}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_ADDRESS2"}
                inputType={"text"}
                value={details?.street2}
                onChange={(value) =>
                {
                    if (details?.street2 === value) return;
                    saveCustomerDetails("street2", value);
                }}
            />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_POSTAL_CODE"}
                value={details?.zip}
                onChange={(value) =>
                {
                    if (details?.zip === value) return;
                    saveCustomerDetails("zip", value);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"PLG_USER_PROFILE_FIELD_CITY_LABEL"}
                inputType={"text"}
                value={details?.city}
                onChange={(value) =>
                {
                    if (details?.city === value) return;
                    saveCustomerDetails("city", value);
                }} />

            <SettingsLanguageTypeAhead
                disabled={!allowedToEdit}
                id="languageCustomerSetting"
                value={details.country}
                onChange={(data) =>
                {
                    const { alpha3 } = data;
                    saveCustomerDetails("country", alpha3);
                }}
            />
        </SettingsCol>
        <SettingsCol>

            <CustomerTypeAhead
                id="customer-main-setting"
                label="COM_FACPMANAGEMENT_CUSTOMER_FIELD_PARENT_LABEL"
                skipTrees={[customer.tree!]}
                disabled={allowedToEdit ? !permissionAllowed(myPermissions.isAdmin!) : true}
                currentId={customer.parentId || ""}
                onChange={(customerId => saveCustomer("parentId", customerId))}
            />
            <Feature feature="SETTINGS_TEMPLATE">
                <IonItem>
                    <IonButton
                        disabled={!allowedToEdit}
                        className={style.btn}
                        style={{ width: "100%" }}
                        expand="full"
                        onClick={() => { }}
                    >
                        {t("COM_FACPMANAGEMENT_USER_FIELD_ISTEMPLATE_LABEL")}
                    </IonButton>
                </IonItem>
            </Feature>
        </SettingsCol>
        <SettingsCol>

        </SettingsCol>
    </>;
};

export default MainSettings;
